<template>
    <v-overlay
        :model-value="overlay"
        class="align-center justify-center"
        persistent
    >
        <v-progress-circular
            color="blue-lighten-3"
            indeterminate
            :size="120"
        >
            <v-img
                src="/images/d3_connect.png"
                v-if="overlay"
                :size="10"
                class="loading-spinner"
                :style="{
                            marginLeft: '9px',
                        }"
                indeterminate
            ></v-img>
        </v-progress-circular>
    </v-overlay>

    <v-card class="overflow-y-auto" width="100%" height="100%" variant="elevated" elevation="5" id="job-entry-page">
        <div class="h-100 mb-0 container row" width="100%" :dense="true" @mousemove="drag" @mouseup="endDrag">
            <div class="pa-2" id="left" ref="target" :style="{ width: leftWidth + 'px' }">
                <BomComponent
                    @tree-item-selected="bomTreeSelectedHandler"
                />
            </div>

            <div class="draggable" ref="draggable" @mousedown="startDrag"></div>

            <div id="right" class="flex-grow" :style="{ width: rightWidth + 'px' }">
                <v-sheet class="pa-2">
                    <JobEntryDetails
                        @job-selected-from-search="jobSelectedFromSearchHandler"
                        @job-updated="jobUpdatedHandler"
                        ref="JobEntryDetailsRef"
                    />
                </v-sheet>
            </div>
        </div>
        <NewJobModal />
    </v-card>

    <v-snackbar
        v-model="temporaryBool"
    >
        {{ temporaryMessage }}
    </v-snackbar>
</template>

<script>
    import {useJobEntryStore} from "../../stores/ProjectManagement/JobEntry";
    import { mapWritableState } from "pinia";
    import axios from "axios";
    import AuthLayout from "../../Layouts/AuthLayout.vue"
    import JobEntryDetails from "../../components/ProjectManagement/JobEntry/JobEntryDetails.vue"
    import BomComponent from "../../components/ProjectManagement/JobEntry/BomComponent.vue"
    import NewJobModal from "../../components/ProjectManagement/JobEntry//Modals/NewJobModal.vue"

    export default {
        name: "JobEntry",
        components: {
            AuthLayout,
            JobEntryDetails,
            BomComponent,
            NewJobModal
        },
        computed: {
            ...mapWritableState(useJobEntryStore, {
                job: "job",
                levelOneTab: "levelOneTab",
                levelTwoTab: "levelTwoTab",
                levelThreeTab: "levelThreeTab",
                overlay: "overlay",
                temporaryMessage: "temporaryMessage",
                temporaryBool: "temporaryBool",
                setErrorMessage: "setErrorMessage",
                setTemporaryMessage: "setTemporaryMessage",
                selectedOperations: "selectedOperations",
                selectedParts: "selectedParts",
                initCurrentAssembly: "initCurrentAssembly",
                setCurrentMaterial: "setCurrentMaterial",
                setCurrentOperation: "setCurrentOperation",
                fetchJobData: "fetchJobData",
                setJob: "setJob"
            }),
            pageWidth() {
                return document.getElementById('job-entry-page').offsetWidth;
            }
        },
        data() {
            return {
                isDragging: false,
                startX: 0,
                initialWidth: null,
                leftWidth: null,
                rightWidth: null
            }
        },
        mounted() {
            window.addEventListener('resize', () => {
                this.initialWidth = this.leftWidth = this.pageWidth / 2;
            });

            this.initialWidth = this.pageWidth / 2,
            this.leftWidth = this.pageWidth / 2,
            this.rightWidth = this.pageWidth / 2
        },
        watch: {},
        methods: {
            startDrag(event) {
                this.isDragging = true;
                this.startX = event.clientX;
            },
            drag(event) {
                if (this.isDragging) {
                    const deltaX = event.clientX - this.startX;
                    this.leftWidth = Math.max(this.initialWidth + deltaX, this.pageWidth * 0.1);
                    this.rightWidth = this.pageWidth - this.leftWidth
                }
            },
            endDrag() {
                this.isDragging = false;
                this.initialWidth = this.leftWidth;
            },
            jobSelectedFromSearchHandler(selectedJob) {
                this.job = selectedJob;
            },
            jobUpdatedHandler(newValue) {
                this.job = newValue
            },
            async sendCall(data) {
                if (data.type === "parts") {
                    this.overlay = true;
                    let partsString = "[";
                    this.selectedParts.forEach((part) => {
                        partsString += part.PartNum + ",";
                    })
                    partsString += "]"

                    let params = {
                        PartsString: partsString,
                        ParentAssemblySeq: data.ParentAssemblySeq,
                        JobNum: this.job.JobNum,
                        oprSeq: data?.OprSeq
                    }

                    await axios.post(route('api.epicor.jobs.attach.part'), params)
                        .then(async (response) => {
                            if (response.data.Status) {
                                this.selectedOperations = [];
                                this.selectedParts = [];
                                await this.refreshBom()
                                this.levelOneTab = "Engineering"
                                this.levelTwoTab = "Parts"

                                if (response.data.Message) {
                                    this.setErrorMessage(response.data.Message)
                                } else {
                                    this.setTemporaryMessage("Part(s) have been added to the BOM")
                                }

                            } else {
                                this.selectedOperations = [];
                                this.selectedParts = [];
                                this.setErrorMessage(response.data.Message)
                                this.selectedOperations = [];
                                this.selectedParts = [];
                            }
                        })
                        .catch((response) => {
                            console.log("Err: " + response)
                            this.overlay = false;
                            this.selectedOperations = [];
                            this.selectedParts = [];
                        })
                } else if (data.type === "operations") {
                    this.overlay = true;
                    let operationsString = "[";
                    this.selectedOperations.forEach((opr) => {
                        operationsString += opr.OpCode + ",";
                    })
                    operationsString += "]"

                    let params = {
                        operationsString: operationsString,
                        ParentAssemblySeq: data.ParentAssemblySeq,
                        JobNum: this.job.JobNum,
                    }

                    await axios.post(route('api.epicor.jobs.attach.operation'), params)
                        .then(async (response) => {
                            if (response.data.Status) {
                                this.selectedOperations = [];
                                this.selectedParts = [];
                                await this.refreshBom()
                                this.levelOneTab = "Engineering"
                                this.levelTwoTab = "Operations"

                                if (response.data.Message) {
                                    this.setErrorMessage(response.data.Message)
                                } else {
                                    this.setTemporaryMessage("Operation(s) have been added to the BOM")
                                }

                            } else {
                                this.selectedOperations = [];
                                this.selectedParts = [];
                                this.setErrorMessage(response.data.Message)
                                this.selectedOperations = [];
                                this.selectedParts = [];
                            }
                        })
                        .catch((response) => {
                            console.log("Err: " + response)
                            this.overlay = false;
                            this.selectedOperations = [];
                            this.selectedParts = [];
                        })
                }
            },
            async refreshBom() {
                let JobNum = this.job.JobNum;
                let job = await this.fetchJobData(JobNum);
                this.setJob(job)
                this.overlay = false;
            },
            async bomTreeSelectedHandler(selectionData) {
                if (this.selectedOperations.length || this.selectedParts.length) {
                    if (selectionData.node?.type === "subcategory" && (selectionData.node?.title === "Materials" || selectionData.node?.title === "Subassemblies") && this.selectedParts.length) {
                        let data = { type: "parts", ParentAssemblySeq: selectionData.node.parent.node.details.AssemblySeq }
                        await this.sendCall(data)

                    } else if (selectionData.node?.type === "subcategory" && selectionData.node?.title === "Operations" && this.selectedOperations.length) {
                        let data = { type: "operations", ParentAssemblySeq: selectionData.node?.parent.node.details.AssemblySeq }
                        await this.sendCall(data)

                    } else if (selectionData.node?.type === "operation" && this.selectedParts.length) {
                        let data = { type: "parts", ParentAssemblySeq: selectionData.node.parent.parent.node.details.AssemblySeq, OprSeq: selectionData.node?.details.OprSeq }
                        await this.sendCall(data)

                    }

                    return;
                } else {
                    switch(selectionData.node.type){
                        case 'job':
                            this.levelOneTab = 'Job'
                            this.levelTwoTab = 'Materials'
                            this.levelThreeTab = 'Detail'
                            break
                        case 'assembly':
                            this.initCurrentAssembly(selectionData.node.dataRef?.details?.AssemblySeq)

                            this.levelOneTab = 'Job Details'
                            this.levelTwoTab = 'Assemblies'
                            this.levelThreeTab = 'Assembly'
                            break
                        case 'material':
                            this.initCurrentAssembly(selectionData.node.dataRef?.details?.AssemblySeq)
                            this.setCurrentMaterial(selectionData.node.dataRef?.details?.MtlSeq)

                            this.levelOneTab = 'Job Details'
                            this.levelTwoTab = 'Materials'
                            this.levelThreeTab = 'Detail'
                            break
                        case 'operation':
                            this.initCurrentAssembly(selectionData.node.dataRef?.details?.AssemblySeq)
                            this.setCurrentOperation(selectionData.node.dataRef?.details?.OprSeq)

                            this.levelOneTab = 'Job Details'
                            this.levelTwoTab = 'Operations'
                            this.levelThreeTab = 'Detail'
                            break
                    }
                }
            },

        }
    }
</script>

<style scoped>
    .draggable {
        width: 3px;
        height: 100%;
        background-color: black;
        cursor: col-resize;
        z-index: 1000;
    }
    #right {
        height: 100%;
    }
    .flex-grow {
        flex-grow: 1;
    }
    #left {
        height: 100%;
        position: relative;
    }
    .row {
        display: flex;
        margin: -4px;
    }
</style>
